import script from "./InputSchoolInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSchoolInfoModal.vue?vue&type=script&setup=true&lang=js"

export default script